<template>
  <fragment>
    <template v-if="c_isShowTimeAgo">
      <timeago :datetime="datetime" locale="zh-CN" :auto-update="60" />
    </template>
    <template v-else>
      <time>{{ new Date(datetime).toLocaleString('zh-CN') }}</time>
    </template>
  </fragment>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'TimeAndAgo',

  props: {
    datetime: {
      type: Number,
      default: () => new Date().getTime(),
    },
  },

  data: () => {
    return {
      //
    };
  },

  computed: {
    ...mapState({
      ms_currentServerTime: 'currentServerTime',
    }),

    c_isShowTimeAgo() {
      return this.ms_currentServerTime - this.datetime < 24 * 60 * 60 * 1000;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
